export default {
  namespaced: true,
  state: {
    buttonsDisabled: false,
    pointerEvent: "initial",
  },
  getters: {
    buttonsDisabled: state => state.buttonsDisabled,
    pointerEvent: state => state.pointerEvent,
  },
  actions: {
    setButtonsDisabled: (context, disabled) => context.commit("setButtonsState", disabled),
    setPointerEvent: (context, eventName) => context.commit("setPointerEvent", eventName),
  },
  mutations: {
    setButtonsState: (state, disabled) => {
      state.buttonsDisabled = disabled;
    },
    setPointerEvent: (state, eventName) => {
      state.pointerEvent = eventName;
    },
  },
};
